<template>
  <div class="login-wrapper">
    <div class="login-container">
      <v-card class="login-card elevation-24">
            <!-- Header -->
            <div class="login-header">
              <div class="logo-container">
                <img
                  src="/img/bice-logo.png"
                  alt="Logo"
                  class="logo-img"
                />
              </div>
              <h1 class="login-title">Iniciar Sesión</h1>
            </div>

            <!-- Form -->
            <v-card-text class="login-form-container">
              <v-form ref="form" v-model="valid" @submit.prevent="login">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Correo Electrónico"
                  name="email"
                  prepend-inner-icon="mdi-email-outline"
                  type="email"
                  required
                  :disabled="loading"
                  outlined
                  class="mb-4 large-field"
                  color="#28385C"
                  height="56"
                ></v-text-field>

                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  label="Contraseña"
                  name="password"
                  prepend-inner-icon="mdi-lock-outline"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="showPassword = !showPassword"
                  required
                  :disabled="loading"
                  outlined
                  class="mb-3 large-field"
                  color="#28385C"
                  height="56"
                ></v-text-field>

                <!-- Forgot password link -->
                <div class="text-right mb-4">
                  <a
                    href="#"
                    @click.prevent="goToForgotPassword"
                    class="forgot-password-link"
                  >
                    ¿Olvidaste tu contraseña?
                  </a>
                </div>

                <div
                  v-if="errorMessage"
                  style="color: #d32f2f; padding: 12px 0; margin-bottom: 16px; font-size: 14px; text-align: center;"
                >
                  {{ errorMessage }}
                </div>

                <v-btn
                  block
                  x-large
                  color="#28385C"
                  dark
                  :loading="loading"
                  :disabled="!valid || loading"
                  @click="login"
                  class="login-btn"
                  elevation="2"
                  height="64"
                >
                  <v-icon left size="24">mdi-login</v-icon>
                  <span class="btn-text">Ingresar</span>
                </v-btn>
              </v-form>
            </v-card-text>

            <!-- Footer -->
            <v-divider></v-divider>
            <div class="login-footer">
              <p class="footer-text">
                <v-icon small color="#666">mdi-shield-check</v-icon>
                Conexión segura y encriptada
              </p>
            </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginBice",
  data() {
    return {
      valid: false,
      email: "",
      password: "",
      showPassword: false,
      loading: false,
      errorMessage: "",
      emailRules: [
        v => !!v || "El correo electrónico es requerido",
        v => /.+@.+\..+/.test(v) || "El correo electrónico debe ser válido"
      ],
      passwordRules: [
        v => !!v || "La contraseña es requerida",
        v => v.length >= 6 || "La contraseña debe tener al menos 6 caracteres"
      ]
    };
  },
  methods: {
    async login() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.errorMessage = "";

      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/login_bice`,
          {
            email: this.email,
            password: this.password
          },
          {
            validateStatus: function (status) {
              return status < 500;
            }
          }
        );

        if (response.status === 200 && response.data && response.data.success && response.data.token) {
          localStorage.setItem("auth_token", response.data.token);
          localStorage.setItem("uid", response.data.uid);
          localStorage.setItem("login_method", "bice");
          this.axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`;
          this.$router.push("/").catch(() => {});
        } else {
          this.errorMessage = (response.data && response.data.message) || "Correo electrónico o contraseña incorrectos.";
          this.autoClearError();
        }
      } catch (error) {
        if (error.response) {
          this.errorMessage =
            error.response.data?.message ||
            "Correo electrónico o contraseña incorrectos.";
        } else if (error.request) {
          this.errorMessage =
            "No se pudo conectar con el servidor. Verifica tu conexión a internet.";
        } else {
          this.errorMessage =
            "Error al procesar la solicitud. Por favor, intenta nuevamente.";
        }
        this.autoClearError();
      } finally {
        this.loading = false;
      }
    },
    autoClearError() {
      if (this._errorTimer) clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    },
    goToForgotPassword() {
      this.$router.push("/forgot-password").catch(() => {});
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  z-index: 9999;
}

.login-container {
  min-height: 100vh;
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.login-header {
  background: #28385C;
  padding: 40px 40px 36px;
  text-align: center;
  color: white;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.logo-img {
  width: 140px;
  height: auto;
  object-fit: contain;
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.5px;
}

.login-form-container {
  padding: 40px !important;
}

.large-field {
  font-size: 15px;
}

.large-field >>> input {
  font-size: 15px;
}

.large-field >>> .v-label {
  font-size: 15px;
}

.forgot-password-link {
  color: #28385C;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.forgot-password-link:hover {
  color: #1e2a40;
  text-decoration: underline;
}

.login-btn {
  text-transform: none;
  border-radius: 10px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(40, 56, 92, 0.25) !important;
}

.btn-text {
  font-size: 16px;
  font-weight: 600;
}

.login-footer {
  padding: 20px 40px;
  text-align: center;
  background: #f8f9fa;
}

.footer-text {
  margin: 0;
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* Tablet */
@media (max-width: 768px) {
  .login-container {
    padding: 30px 16px;
  }

  .login-card {
    max-width: 460px;
  }

  .login-header {
    padding: 36px 32px 32px;
  }

  .logo-img {
    width: 130px;
  }

  .login-title {
    font-size: 26px;
  }

  .login-form-container {
    padding: 32px !important;
  }

  .login-footer {
    padding: 18px 32px;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .login-container {
    padding: 20px 16px;
  }

  .login-card {
    border-radius: 12px;
  }

  .login-header {
    padding: 28px 24px 24px;
  }

  .logo-img {
    width: 110px;
  }

  .login-title {
    font-size: 24px;
  }

  .login-form-container {
    padding: 24px !important;
  }

  .large-field {
    font-size: 14px;
  }

  .large-field >>> input {
    font-size: 14px;
  }

  .large-field >>> .v-label {
    font-size: 14px;
  }

  .login-btn {
    height: 52px !important;
    font-size: 15px;
  }

  .btn-text {
    font-size: 15px;
  }

  .login-footer {
    padding: 16px 24px;
  }

  .footer-text {
    font-size: 12px;
  }
}
</style>
